import React,{useState} from 'react';
import Nav from '../elements/nav/Nav';
// import Footer from '../elements/footer/Footer';
import './tool-boxShadow.css'

function Boxshadow() {
    const [Xaxis, setXaxis] = useState(20);
    const [Yaxis, setYaxis] = useState(20);
    const [Sblur, setSblur] = useState(5);
    const [Scolor, setScolor] = useState("#696969");
    const [Splace, setSplace] = useState(false);
    const [Fsize, setFsize] = useState(13);
    const [Br, setBr] = useState(15);
    const [PaddingX, setPaddingX] = useState(55);
    const [PaddingY, setPaddingY] = useState(55);
    const [Dcolor, setDcolor] = useState("#3F3A64");
    const [Fcolor, setFcolor] = useState("#f6f6f6");

    const cssboxs = {
        padding: `${PaddingY}px ${PaddingX}px`,
        borderRadius: `${Br}px`,
        boxShadow: `${Splace?"inset":""} ${Xaxis}px ${Yaxis}px ${Sblur}px ${Scolor}`,
        background: `${Dcolor}`
    }
    
    return(
        <>
            <Nav />

            <div className='main-hold'>
                <div className='main-hold-2'>
                    <div className='div-input main-hold-2-1'>

                        <div className='div-output-hold div-output-mob'>
                            <div className='head-div'>
                                <p>Box-shadow output!</p>
                            </div>

                            <div className='output-preview'>
                                <div className='box-test' style={cssboxs}>
                                    <div className='display-output'>

                                        <p style={{fontSize: `${Fsize}px`, color: `${Fcolor}`}}>X-Axis: {Xaxis}px <br />
                                        Y-Axis: {Yaxis}px <br />
                                        Blur: {Sblur}px <br />
                                        {Splace?"Inset: True":"Inset: False"} <br />
                                        Color: {Scolor}</p>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='head-div'>
                            <p>Box-shadow css properties!</p>
                        </div>
                        
                        <div className='label-input-div padding-1'>
                            <label htmlFor="x-axis" className='padding-bottom-1'>X Axis in pixel: {Xaxis}px</label>
                            <input type="range" name='x-axis' min="-200" max="200" value={Xaxis} onChange={(e)=>setXaxis(e.target.value)} />
                        </div>
 
                        <div className='label-input-div padding-1'>
                            <label htmlFor="y-axis" className='padding-bottom-1'>Y Axis in pixel: {Yaxis}px</label>
                            <input type="range" name='y-axis' min="-200" max="200" value={Yaxis} onChange={(e)=>setYaxis(e.target.value)} />
                        </div>

                        <div className='label-input-div padding-1'>
                            <label htmlFor="blur" className='padding-bottom-1'>Shadoe blur: {Sblur}px</label>
                            <input type="range" name='blur' min="0" max="50" value={Sblur} onChange={(e)=>setSblur(e.target.value)} />
                        </div>

                        <div className='size-100-div'>
                            <div className='size-60-div padding-1'>
                                <div className='color-label-input-div'>
                                    <label htmlFor="s-colour">Shadow Colour:&nbsp; </label>
                                    <input type="color" name='s-colour' value={Scolor} onChange={(e)=>setScolor(e.target.value)} />
                                </div>
                            </div>

                            <div className='size-40-div padding-1'>
                                <div className='yes-no-div'>
                                    <label htmlFor="inset">Inset : &nbsp; </label>
                                    <input type="checkbox" checked={Splace} onChange={()=>setSplace(!Splace)} />
                                </div>
                            </div>
                        </div>

                        <div className='more-properties-div padding-1'>
                            <hr />

                            <div className='more-properties-div-hold'>
                                <div className='more-properties-head-div'>
                                    <p>Box properties <span>&#40;Adittional&#41;</span></p>
                                </div>

                                <div className='more-properties-text-div' onClick={
                                    function showMore() {
                                        console.log("Show more is clicked")
                                        const showDiv = document.getElementById("display-status");
                                        showDiv.classList.toggle("display-none")
                                        const showIcon = document.getElementById("show-more-icon");
                                        showIcon.classList.toggle("show-more-icon-toggle")
                                        const inText = document.getElementById("more-properties-text");
                                        if(inText.innerHTML === "more"){
                                            inText.innerHTML = "less";
                                        } else {
                                            inText.innerHTML = "more";
                                        }
                                    }
                                }>
                                    <p id='more-properties-text'>less</p><i className="fas fa-chevron-circle-up" id='show-more-icon'></i>
                                </div>
                            </div>
                        </div>
                        
                        <div className='display-show' id='display-status'>

                            <div className='size-100-div'>
                                <div className='size-50-div padding-1'>
                                    <div className='label-input-div'>
                                        <label htmlFor="br" className='padding-bottom-1'>Font size: {Fsize}px</label>
                                        <input type="range" name='br' min="0" max="25" value={Fsize} onChange={(e)=>setFsize(e.target.value)} />
                                    </div>
                                </div>

                                <div className='size-50-div padding-1'>
                                    <div className='label-input-div'>
                                        <label htmlFor="br" className='padding-bottom-1'>Border radius: {Br}px </label>
                                        <input type="range" name='br' min="0" max="50" value={Br} onChange={(e)=>setBr(e.target.value)} />
                                    </div>
                                </div>
                            </div>

                            <div className='size-100-div'>
                                <div className='size-50-div padding-1'>
                                <div className='label-input-div'>
                                        <label htmlFor="padding" className='padding-bottom-1'>Padding X-axis: {PaddingX}px</label>
                                        <input type="range" name='padding' min="0" max="100" value={PaddingX} onChange={(e)=>setPaddingX(e.target.value)} />
                                    </div>
                                </div>

                                <div className='size-50-div padding-1'>
                                    <div className='label-input-div'>
                                        <label htmlFor="padding" className='padding-bottom-1'>Padding Y-axis: {PaddingY}px</label>
                                        <input type="range" name='padding' min="0" max="100" value={PaddingY} onChange={(e)=>setPaddingY(e.target.value)} />
                                    </div>
                                </div>
                            </div>

                            <div className='size-100-div'>
                                <div className='size-50-div padding-1'>
                                    <div className='color-label-input-div'>
                                        <label htmlFor="d-colour">Div Colour:&nbsp; </label>
                                        <input type="color" name='d-colour' value={Dcolor} onChange={(e)=>setDcolor(e.target.value)} />
                                    </div>
                                </div>

                                <div className='size-50-div padding-1'>
                                    <div className='color-label-input-div'>
                                        <label htmlFor="colour">Font Colour:&nbsp; </label>
                                        <input type="color" value={Fcolor} onChange={(e)=>setFcolor(e.target.value)} />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className='div-output main-hold-2-2'>
                        <div className='div-output-hold div-output-normal'>
                            <div className='head-div'>
                                <p>Box-shadow output!</p>
                            </div>

                            <div className='output-preview padding-1'>
                                <div className='box-test' style={cssboxs}>
                                    <div className='display-output'>

                                        <p style={{fontSize: `${Fsize}px`, color: `${Fcolor}`}}>X-Axis: {Xaxis}px <br />
                                        Y-Axis: {Yaxis}px <br />
                                        Blur: {Sblur}px <br />
                                        {Splace?"Inset: True":"Inset: False"} <br />
                                        Color: {Scolor}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        

                        <div className='sub-head-div-1 padding-1'>
                            <p><i className="fas fa-chevron-circle-right"></i>Copy box-shadow CSS code!</p>
                        </div>

                        <div className='output-code-div padding-1'>
                            <pre>
                                <code>
                                   <span className='body-code'>box-shadow:{Splace? " inset":""} {Xaxis}px {Yaxis}px {Sblur}px {Scolor};</span>
                                </code>
                            </pre>
                        </div>

                        <div className='sub-head-div-1 padding-1'>
                            <p><i className="fas fa-chevron-circle-right"></i>Additional box CSS code!</p>
                        </div>

                        <div className='output-code-div padding-1'>
                            <pre>
                                <code>
                                    <span className='body-code'>padding: {PaddingY}px {PaddingX}px; <br /></span>
                                    <span className='body-code'>font-size: {Fsize}px; <br /></span>
                                    <span className='body-code'>color: {Fcolor}; <br /></span>
                                    <span className='body-code'>border-radius: {Br}px; <br /></span>
                                    <span className='body-code'>background: {Dcolor}; <br /></span>
                                    <span className='body-code'>box-shadow:{Splace? " inset":""} {Xaxis}px {Yaxis}px {Sblur}px {Scolor};</span>
                                </code>
                            </pre>
                        </div>
                    </div>
                </div>
            </div>

            {/* <Footer /> */}

        </>
    );
}

export default Boxshadow;